/**
 * ngx-translate loads `/assets/i18n/{lang}.json`. Those requests must not go through
 * auth/loader interceptors so JSON is always applied to TranslateService.
 */
export function isTranslationAssetRequest(url: string): boolean {
    return url.includes('/assets/i18n/') && url.includes('.json');
}
